<template>
    <div class="col-sm-9">
        <div class="new_soproni_small_area">
            <div class="row">
                <div class="col-sm-12">
                    <div class="section_title_box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="section_title">
                                    <div class="section_title_cont text-left">
                                        <h3>FIÓK BEÁLLÍTÁSOK</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-sm-12">
                    <div class="ked_menu_box">
                        <div class="ked_menu_box_cont">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="szem_title">
                                        <p>FIÓKOM ADATAI</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="kedvenciam_all_area for_nw_form">
                    <div class="col-sm-12">
                        <div class="single_kedvenciam_all">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="vezteknev_title">
                                        <h6>E-mail cím:</h6>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        {{email}}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="vezteknev_title">
                                        <h6>Rövid név (becenév):</h6>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <input class="form-control" type="name" placeholder="" name="firstname" required="" v-model="name">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="vezteknev_title">
                                        <h6>Régi jelszó:</h6>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <input class="form-control" type="password" placeholder="" required="" v-model="passwordOld">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="vezteknev_title">
                                        <h6>Jelszó:</h6>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <input class="form-control" type="password" placeholder="" required="" v-model="password">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="vezteknev_title">
                                        <h6>Jelszó újra:</h6>
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="form-group">
                                        <input class="form-control" type="password" placeholder="" required="" v-model="password2">
                                    </div>
                                    <div class="mentes_small">
                                        <a @click="update">MENTÉS</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins:[Endpoints],
    data:function () {
        return {
            email: '',
            password: '',
            password2: '',
            passwordOld: '',
            name: '',
        };
    },
    created:function () {
        var self = this;
        this.connProfileGet(function (r) {
            var u = r.data.user;
            self.email = u.email;
            self.name = u.name;
        })
    },
    mounted:function () {
        this.$store.state.backArrow = true;
    },
    beforeDestroy:function () {
        this.$store.state.backArrow = false;
    },
    methods:{
        update:function () {
            var self = this;

            if(this.name.length <3){
                toastr.error('A név túl rövid')
                return
            }

            var header;
            if (this.password == '' && this.password2 == '' && this.passwordOld == ''){
                header = {}
            }else{
                if (this.password.length <6 ){
                    toastr.warning('A jelszónak legalább 6 karakter hosszúnak kell lennie')
                    return
                }else if (this.password != this.password2){
                    toastr.error("A beírt jelszavak nem egyeznek");
                    return
                }

                header = this.createHeader();
            }

            this.connProfileUpdate(header,{'name':this.name},function success(r) {
                toastr.success('Az adatok elmentésre kerültek')
            },function error(r) {
                if (r.data.errorCode == 1008){
                    toastr.warning('A régi jelszó nem megfelelő')
                }else{
                    toastr.error('Az adatok hibásan lettek kitöltve, kérlek ellenőrizd őket')
                }
            })
        },
        createHeader:function () {
            var o = {
                'Authorization':btoa(this.passwordOld+':'+this.password)
            }
            return o;
        },
    }
}
</script>



// WEBPACK FOOTER //
// Settings.vue?54d59943